import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashReceiptRegisterReport extends Layout {
    excludabletextboxCustomer: ExcludableTextbox;
    sourceCashReceiptRegister: DataSource;
    switchSortBy: Switch;
    textboxDateRange: Textbox;
    textboxReportType: Textbox;
}
